import {Object3D} from 'three'
import {BaseLoader} from './BaseLoader'
import {ONRENTED_CONSTANTS} from '@/components/MapContext/ThreeJs/DataOfThreeJS/OnRentedLoader/OnRentedConstants'
import {Font} from 'three/examples/jsm/loaders/FontLoader.js'
import {createTextMesh} from './utils/createTextMesh'

export default class OnRentedLoader extends BaseLoader {
  private onRentedModel: Object3D | null = null
  private objectCounter = 0
  private fontRef: React.RefObject<Font | null> | null = null

  setFontRef(fontRef: React.RefObject<Font | null>): void {
    this.fontRef = fontRef
    this.createRentedModel()
  }

  async waitForLoad(): Promise<void> {
    return Promise.resolve()
  }

  private createRentedModel(): void {
    if (!this.fontRef || !this.fontRef.current) {
      return
    }

    const mesh = createTextMesh({
      text: 'RENTED',
      font: this.fontRef.current,
      color: 0xff0000,
    })

    mesh.scale.set(
      ONRENTED_CONSTANTS.MODEL_SCALE,
      ONRENTED_CONSTANTS.MODEL_SCALE,
      ONRENTED_CONSTANTS.MODEL_SCALE
    )

    this.onRentedModel = mesh
  }

  clearAllOnRentedObjects(): void {
    this.clearAll()
  }

  protected onAfterClear(): void {
    this.objectCounter = 0
  }

  get onRentedObjects(): Readonly<Record<string, Object3D>> {
    const result: Record<string, Object3D> = {}
    this.objectsMap.forEach((obj, id) => {
      if (id.startsWith(ONRENTED_CONSTANTS.OBJECT_ID_PREFIX)) {
        const key = id.replace(ONRENTED_CONSTANTS.OBJECT_ID_PREFIX, '')
        result[key] = obj
      }
    })
    return Object.freeze(result) as Readonly<Record<string, Object3D>>
  }

  removeOnRentedObject(object: Object3D): void {
    if (!this.hasThreeLayer()) return

    this.objectsMap.forEach((obj, id) => {
      if (obj === object) {
        this.threeLayer.removeObject(id)
        this.removeObjectFromCollection(id)
      }
    })
  }

  addOnRentedObject(center: [number, number]): Object3D | null {
    if (!this.onRentedModel || !this.hasThreeLayer()) return null
    const object = this.onRentedModel.clone()
    object.position.y = ONRENTED_CONSTANTS.OBJECT_POSITION_Y
    object.rotation.set(0, 0, 0)

    const objectId = this.objectCounter++
    const id = `${ONRENTED_CONSTANTS.OBJECT_ID_PREFIX}${objectId}`
    const group = this.threeLayer.addObject(
      id,
      object,
      center,
      ONRENTED_CONSTANTS.OBJECT_ALTITUDE,
      ONRENTED_CONSTANTS.OBJECT_SCALE
    )

    group.name = id
    this.addObjectToCollection(id, group)

    return group
  }
}
